import React, { useState } from "react";
import { Button, Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import { updateGenericProducts } from "../../../store/slices/productConfigSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAllCommercials } from "../../../store/slices/commericals";

const EditProduct = ({ product,onSuccess }) => {
  const dispatch = useDispatch();
   const allPrograms = useSelector(
    (state) => state.programs.allProgramsData
  ).map((program) => ({
    label: program.name,
    value: program.slug_name,
  }));

const [commercialData, setCommercialData] = useState([]);

  const [editData, setEditData] = useState(product.original);
  const [jsonError, setJsonError] = useState(null);

  const handleFieldChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleJsonChange = (e) => {
    try {
      setEditData(JSON.parse(e.target.value));
      setJsonError(null);
    } catch {
      setJsonError("Invalid JSON");
    }
  };

  const handleSave = async () => {
    try {
      let data = await dispatch(updateGenericProducts(editData));
      toast.success("Product updated successfully");
      if (onSuccess) {
      onSuccess(editData.collection_slug);
    }
    } catch {
      toast.error("Failed to update product");
    }
  };

  const fetchCommercials = async () => {
    let data = await dispatch(getAllCommercials())
    console.log(data.payload, "commercials data");
    const arrayData = data.payload.map((program) => ({
      label: program.discount_type,
      value: program.discount_type,
    }));
    setCommercialData(arrayData);
  };
React.useEffect((
  ) => {
    fetchCommercials();
  }, []);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              {/* Form fields */}
              <div className="mt-3">
                <Label>
                  Name<span className="text-danger">*</span>
                </Label>
                <Input
                  className="form-control digits"
                  value={editData.name || ""}
                  onChange={(e) => handleFieldChange("name", e.target.value)}
                />
              </div>

              <div className="mt-3">
                <Label>Select Collection</Label>
                <Input
                  type="text"
                  name="select"
                  className="form-control digits"
                  value={editData.collection_slug || ""}
                  onChange={(e) => handleFieldChange("collection_slug", e.target.value)}
                  disabled
                />
              </div>

              <div className="mt-3">
                <Label>Select Service</Label>
                <Input
                  type="select"
                  name="select"
                  className="form-control digits"
                  value={editData.service_slug || ""}
                  onChange={(e) => handleFieldChange("service_slug", e.target.value)}
                >
                  <option value="" disabled>
                    -- Select Service --
                  </option>
                  {commercialData.map((service, index) => (
                    <option key={index} value={service.value}>
                      {service.label}
                    </option>
                  ))}
                </Input>
              </div>

              <div className="mt-3">
                <Label>Select Plan</Label>
                <Input
                  type="select"
                  name="select"
                  className="form-control digits"
                  value={editData.program_slug || ""}
                  onChange={(e) => handleFieldChange("program_slug", e.target.value)}
                >
                  <option value="" disabled>
                    -- Select Plan--
                  </option>
                  {allPrograms.map((service, index) => (
                    <option key={index} value={service.value}>
                      {service.label}
                    </option>
                  ))}
                </Input>
              </div>

              {/* JSON Editor */}
              <div className="mb-3 mt-4">
                <label>Edit JSON</label>
                <textarea
                  className="form-control"
                  rows={10}
                  value={JSON.stringify(editData, null, 2)}
                  onChange={handleJsonChange}
                />
                {jsonError && <div className="text-danger">{jsonError}</div>}
                <small className="text-muted">Edit the product object as JSON.</small>
              </div>
              <div className="d-flex justify-content-end">
                <Button color="primary" onClick={handleSave} disabled={!!jsonError}>
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
